import BlurOffIcon from '@mui/icons-material/BlurOff';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import ToggleButton from '@mui/material/ToggleButton';
import { useTranslation } from 'react-i18next';

import LightTooltip from 'src/common/components/styled/LightTooltip';

interface BlockFrostedBackgroundButtonProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
}

export default function BlockFrostedBackgroundButton({
  enabled,
  onChange,
}: BlockFrostedBackgroundButtonProps) {
  const { t } = useTranslation();
  const label = t('system.pages.hero.textFrostedBackground');

  return (
    <LightTooltip title={label} placement="top">
      <ToggleButton
        size="small"
        value="frosted"
        selected={enabled}
        onChange={() => onChange(!enabled)}
        aria-label={label}
        sx={{
          px: 0.75,
          py: 0.5,
          border: 1,
          borderColor: 'divider',
          '&.Mui-selected': {
            borderColor: 'primary.main',
          },
          '&:not(.Mui-selected)': {
            color: 'text.disabled',
          },
        }}
      >
        {enabled ? <BlurOnIcon fontSize="small" /> : <BlurOffIcon fontSize="small" />}
      </ToggleButton>
    </LightTooltip>
  );
}
